import type { SourceExportApiIdentifier } from '@/components/regionen/pageRegionSlug/mapData/mapDataSources/export/exportIdentifier'
import { Link } from '@/components/shared/links/Link'
import { getExportOgrApiUrl } from '@/components/shared/utils/getExportApiUrl'
import type { Formats } from '@/server/api/export/ogrFormats.const'
import { ogrFormats } from '@/server/api/export/ogrFormats.const'

export const downloadFormatLinkClasses =
  'min-w-28 w-max flex-none rounded-md border border-gray-300 bg-gray-50 px-3 py-2 text-left shadow-sm hover:bg-yellow-50 focus:ring-1 focus:ring-yellow-500'

type Props = {
  regionSlug: string
  tableName: SourceExportApiIdentifier
}

export const OgrFormatDownloadLinks = ({ regionSlug, tableName }: Props) => {
  return (
    <>
      {Object.entries(ogrFormats).map(([param, format]) => (
        <Link
          key={param}
          href={getExportOgrApiUrl(regionSlug, tableName, param as Formats)}
          classNameOverwrite={downloadFormatLinkClasses}
          download
          blank
        >
          <strong className="mb-0.5 block text-xs font-medium text-gray-500">Download</strong>
          <span className="block border-0 p-0 font-mono text-gray-900 focus:ring-0 sm:text-sm">
            {format.driver}
          </span>
        </Link>
      ))}
    </>
  )
}
